import React from "react";
import { createTranslator } from '@/modules/i18n';

/**
 * 
 * @param {Object} transifyParams 
 * @param {Number} transifyParams.resourceId 
 * @param {Number} transifyParams.collectionId 
 */

function Translator (WrappedComponent, getMessage = () => {}, config = {}, transifyParams = { collectionId: 1757 }) {
  return class extends React.Component {
    componentWillMount() {
      createTranslator(config, transifyParams.collectionId).then(res => {
        this.setState({
          message: getMessage()
        })
      })
    }

    render () {
      return <WrappedComponent />
    }
  }
}

export default Translator;
